module.exports = __webpack_public_path__ + "img/formula_gold.c32c5dac.gif";